"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var transform = exports.transform = {
  type: "select",
  options: [{ label: "Capitalize", value: "capitalize" }, { label: "Uppercase", value: "uppercase" }, { label: "Lowercase", value: "lowercase" }]
};

var containerSize = exports.containerSize = {
  type: "select",
  options: [{ label: "Container", value: "" }, { label: "Full width", value: "fluid" }]
};